import React, {Component} from 'react';
import PropTypes from "prop-types";

import Modal from "../Modal";
import UserApi from "../../api/UserApi";
import SocialLogin from "./SocialLogin";
import Icon from "../Icon";
import SignInButton from "./SignInButton";

const yup = require('yup');

class RegisterOverlay extends Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    onSignUp: PropTypes.func,
    onClose: PropTypes.func,
    type: PropTypes.string
  };

  constructor(props) {
    super(props);

    this.state = {
      errors: {},
      hidden: false
    }
  }

  onModalHidden() {
    this.setState({ hidden: true });
  }

  onModalShown() {
    this.setState({ hidden: false });
  }

  onSignUp(e) {
    e.preventDefault();

    let schema = yup.object().shape({
      username: yup.string().required(),
      email: yup.string().email().required(),
      password: yup.string().min(6).required()
    });

    let values = {
      email: document.querySelector('.register-form [name="email"]').value,
      username: document.querySelector('.register-form [name="username"]').value,
      password: document.querySelector('.register-form [name="password"]').value
    };

    schema.validate(values, { abortEarly: false }).then(() => {
      UserApi.register(values).then(() => {
        // Api.status(); # TODO

        if (typeof this.props.onSignUp === "function") {
          this.props.onSignUp();
        }
      }).catch((e) => {
        if (e.response.data.errors) {
          let errors = {};
          Object.keys(e.response.data.errors).forEach(key => {
            errors[key] = e.response.data.errors[key].join("\n");
          });
          this.setState({ errors: errors });
        }
      });
    }).catch(error => {
      let errors = {};
      error.inner.forEach(e => {
        errors[e.path] = e.message;
      });
      this.setState({ errors: errors });
    });

    return false;
  }

  render() {
    const { visible } = this.props;
    const { errors, hidden } = this.state;

    return (
      <Modal
        visible={visible}
        onClose={this.props.onClose}
        hidden={hidden}
        header={<h5>Register</h5>}
        footer={
          <SignInButton className={"register-button"} onOpen={this.onModalHidden.bind(this)} onClose={this.onModalShown.bind(this)} onSignIn={this.props.onClose}>
            Already have an Acccount?
          </SignInButton>
        }
      >
        <div className={'row no-gutters'}>
          <div className={'col-4'}>
            <div className={'social-logins'}>
              <h5 className={'mb-3 text-center'}>Use a Social Provider</h5>

              <SocialLogin type={"google"} />
              <SocialLogin type={"discord"} />
              <SocialLogin type={"simply_hentai"} />
            </div>
          </div>
          <div className={'col-8'}>
            <form className={'register-form'} onSubmit={this.onSignUp.bind(this)}>
              <div className={'form-group'}>
                <label>Username</label>
                <input autoComplete={'username'} type={'text'} name={"username"} className={'form-control ' + (errors.username ? 'is-invalid' : '')} />
                {errors.username && <div className={'invalid-feedback'}>{errors.username}</div>}
              </div>

              <div className={'form-group'}>
                <label>E-Mail-Address</label>
                <input autoComplete={'email'} type={'text'} name={"email"} className={'form-control ' + (errors.email ? 'is-invalid' : '')} />
                {errors.email && <div className={'invalid-feedback'}>{errors.email}</div>}
              </div>

              <div className={'form-group'}>
                <label>Password</label>
                <input type={'password'} name={"password"} className={'form-control ' + (errors.password ? 'is-invalid' : '')} />
                {errors.password && <div className={'invalid-feedback'}>{errors.password}</div>}
              </div>

              <button className={'btn btn-primary btn-block icon-right'}>Sign Up <Icon icon={'arrow-right'}/></button>
            </form>
          </div>
        </div>
      </Modal>
    );
  }
}

export default RegisterOverlay;